import { render, staticRenderFns } from "./GemComponent.vue?vue&type=template&id=56018b48&"
import script from "./GemComponent.vue?vue&type=script&lang=js&"
export * from "./GemComponent.vue?vue&type=script&lang=js&"
import style0 from "./GemComponent.vue?vue&type=style&index=0&id=56018b48&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports